var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompetence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 22.5,
    fill: "white",
    stroke: "#ECECEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 11L13 15.3333V21.8333C13 27.8458 17.16 33.4683 22.75 34.8333C28.34 33.4683 32.5 27.8458 32.5 21.8333V15.3333L22.75 11ZM25.4583 23.5558L26.4333 27.7592L22.75 25.5383L19.0667 27.7592L20.0417 23.5667L16.7917 20.7608L21.0817 20.3925L22.75 16.4383L24.4183 20.3817L28.7083 20.75L25.4583 23.5558Z",
    fill: "#F5C112"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompetence);
export default __webpack_public_path__ + "static/media/competence.50ecdbab20f7eacd092ff739040d9d2b.svg";
export { ForwardRef as ReactComponent };